<template>
    <search-layout
        v-if="loaded"
        :map-expanded="mapExpanded"
        :offers-count="filteredOffers.length"
        :search-active="searchActive"
    >
        <template v-slot:breadcrumbs>
            <expired-offers-snackbar :is-offers-expired="isOffersExpired" @refresh="search" />
            <visa-breadcrumbs :search-request="searchRequest" />
        </template>
        <template v-slot:left-sidebar>
            <visa-search-summary :search-request="searchRequest" />
            <sort-select v-model="sortKey" :items="sortItems" />
            <visa-filters
                :filter-values="filterValues"
                :filters="searchResponse.filters"
                :filtered-offers-count="filteredOffers.length"
                :currency="currency"
                @change="changeFilter"
                @reset="resetFilters"
            />
        </template>
        <template v-slot:main-content>
            <search-progress
                :filtered-offers-count="filteredOffers.length"
                :total-offers-count="searchResponse.products.length"
                :search-active="searchActive"
                @stop="stopSearch"
            />
            <visa-offers :offers="offers" />
            <pagination v-model="page" :pages="pages" />
            <conditions-modal>
                <template v-slot:info>
                    <visa-conditions-modal-info />
                </template>
            </conditions-modal>
            <visa-offer-info-modal />
        </template>
    </search-layout>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import MobileSearchPageTabs from '@/components/snippets/MobileSearchPageTabs.vue'
    import Pagination from '~/components/search/Pagination.vue'
    import ConditionsModal from '~/components/modals/ConditionsModal.vue'
    import {SearchPageBase} from '@/mixins/SearchPageBase.vue'
    import ExpiredOffersSnackbar from '@/components/search/ExpiredOffersSnackbar.vue'
    import SearchProgress from '~src/components/search/searchProgress.src'
    import SortSelect from '@/components/search/SortSelect.vue'
    import VisaBreadcrumbs from '@/components/visa/VisaBreadcrumbs.vue'
    import GroupOffersSelect from '@/components/search/GroupOffersSelect.vue'
    import SearchLayout from '~src/components/parts/searchLayout.src'
    import {SearchPageMixin} from '@/components/mixins/SearchPageMixin.vue'
    import {Tmp_SearchPageBase} from '@/mixins/Tmp_SearchPageBase.vue'
    import VisaSearchSummary from '@/components/visa/search/VisaSearchSummary.vue'
    import VisaOffers from '@/components/visa/search/offers/VisaOffers.vue'
    import {VisaStoreMixin} from '@/mixins/VisaStoreMixin.vue'
    import VisaConditionsModalInfo from '@/components/visa/snippets/VisaConditionsModalInfo.vue'
    import VisaOfferInfoModal from '@/components/visa/info/VisaOfferInfoModal.vue'
    import VisaFilters from '~/components/visa/search/VisaFilters.vue'

    @Component({
        components: {
            VisaOfferInfoModal,
            VisaConditionsModalInfo,
            VisaFilters,
            VisaOffers,
            VisaSearchSummary,
            VisaBreadcrumbs,
            SortSelect,
            SearchProgress,
            ExpiredOffersSnackbar,
            Pagination,
            MobileSearchPageTabs,
            ConditionsModal,
            SearchLayout,
            GroupOffersSelect,
        },
        async setup() {
            const route = useRoute()
            await useAsyncData(`visa-${route.query.countryId}`, async () => {
                await useVisaRuntimeData(route)
                return true
            })
        },
    })
    export class VisaSearchPage extends mixins(SearchPageBase, Tmp_SearchPageBase, SearchPageMixin, VisaStoreMixin) {
        mapPoints = []

        // get dates() {
        //     return `${this.formattedDate(this.searchRequest.startDate)} - ${this.formattedDate(
        //         this.searchRequest.endDate
        //     )}`
        // }

        // formattedDate(date) {
        //     return date ? this.$filters.dateFormat(this.$dateFns.parseISO(date)) : ''
        // }
    }

    export default VisaSearchPage
</script>
